import React, { useEffect } from 'react';

import ICartResponse from 'network/response/ICart';
import useClickAndCollect from 'pages/Checkout/components/ShipmentsNew/hooks/useClickAndCollect.hook';
import ShipmentsNew from '../ShipmentsNew';
import { CncGTMEvents, CncTrack } from 'pages/Checkout/helpers';

interface Props {
  cartData: ICartResponse;
}

const Shipments: React.FC<Props> = ({ cartData, ...rest }) => {
  const { isEnableClickAndCollect } = useClickAndCollect();

  const Component = ShipmentsNew;

  useEffect(() => {
    // Track CNC option
    if (isEnableClickAndCollect) {
      CncTrack(CncGTMEvents.cnc_available, {
        cc_store_id: '',
        cc_store_name: '',
        cc_selected_timeslot: '',
        cc_default_timeslot: '',
      });
    }
  }, [isEnableClickAndCollect]);

  return (
    <Component
      marketPlaceDeliveryCost={cartData.marketPlaceDeliveryCost}
      isCnc={isEnableClickAndCollect}
      {...rest}
    />
  );
};

export default Shipments;
